import React from "react";
import {Select} from "antd";
import BaseComponent from "../../redare/components/BaseComponent";
import DictionaryPresenter from "../../.gen/presenter/DictionaryPresenter";

export default class DictSelect extends BaseComponent {

    constructor(props) {
        super(props);
        this.dictPresenter = new DictionaryPresenter(this);
        this.state = {
            loading: true,
            dArray: []
        }
    }

    componentDidMount() {
        let code = this.props.code;
        if (code) {
            this.dictPresenter.findDictionaryList(
                {parentCode: this.props.code},
                {},
                (success_re) => {
                    setTimeout(() => {
                        this.setState({loading: false, dArray: success_re.data});
                    }, 500);
                },
                (fail_re) => {
                    this.setState({loading: false});
                }
            );
        } else {
            this.setState({loading: false});
        }
    }


    render() {
        let dArray = this.state.dArray;
        let matchkey = 'id';
        if (this.props.matchkey) {
            matchkey = this.props.matchkey;
        }
        return (
            <Select
                placeholder="请选择"
                style={{width: '100%'}}
                defaultValue={this.props.value}
                loading={this.state.loading}
                {...this.props}
            >
                {
                    dArray.map((item) => {
                        return <Select.Option key={"option_" + item.id} value={item[matchkey]}
                                              data={item}>{item.dicName}</Select.Option>
                    })
                }
            </Select>
        );
    }
}